<template lang="pug">
  div.registry.objects
    e-toolbar(
      :items="items"
      @deleteItems="deleteItems"
      :hideRemoveButton="true"
      :showTotal="true"
      :showExport="true"
      :endpointExport="getEndpointExport()"
    )

      .display-flex.align-items-center(slot="filter-status" v-if='hasObjectFilterStatus' style="gap:10px" )
        object-tko-filter(v-if="hasObjectsTkoFilter" @changeTkoFilter="reFetchData")
        .objects__status
          button.reset-btn.button.button_usual(@click.stop="showFilterStatus = !showFilterStatus") Статус
          .filter-popup(v-show='showFilterStatus' @click.stop="")
            .item.filter-popup__item(v-for="item in statuses")
              .custom-checkbox
                input.checkbox.custom-checkbox__input.visually-hidden(
                  type="checkbox"
                  :id="'checkbox-' + item.id"
                  v-model="fields.statuses"
                  :value="item.id"
                  @change='requestWithStatus'
                )
                label.custom-checkbox__label(:for="'checkbox-' + item.id")
                  .custom-checkbox__block
                  .custom-checkbox__text {{ item.name }}
    table-filter(
      v-if="hasTableFilterObjects"
      :attributes='items._meta.fields'
      :dataUrl="filterEndpoint"
      @updateItems='updateItems'
    )
    e-table(
      :items="items"
      @deleteItem="deleteItem"
      @editItem="editItem"
      :showCheckbox="false"
      :marginBottom='30'
    )

    router-view
</template>

<script>
import { core, tko, export_document } from '@/api/api-endpoints'
import tableMixin from '@/components/table/table-mixin'
import hasMixin from '@/mixins/has-mixin'
import tableFilterMixin from './mixins/table-filter-mixin'
import objectTkoFilter from './components/object-tko-filter'

export default {
  components: { objectTkoFilter },
  mixins: [tableMixin, tableFilterMixin, hasMixin],
  data: () => ({
    fields: {
      statuses: [],
    },
    showFilterStatus: false,
    statuses: [],
  }),
  methods: {
    getEndpoint(route) {
      return tko.objects(route)
    },
    getDeleteUrl(id) {
      return tko.objectDelete(id)
    },
    getEndpointExport() {
      return export_document.tkoObject(this.$route)
    },
    async getStatuses() {
      this.statuses = (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: core.collection('status', {
            query: { type: 'tko_object' },
          }),
        })
      ).data.status
      this.fields.statuses = this.statuses.map((item) => String(item.id))
    },
    requestWithStatus() {
      const route = this.$route
      route.query.status_ids = this.fields.statuses.join()
      this.reFetchData()
    },
    outerClick() {
      this.showFilterStatus = false
    },
    async reFetchData() {
      this.$bar.start()
      const route = this.$route

      const response = await this.$store.dispatch('updateUrlEndpoint', {
        endpoint: tko.objects(route),
      })

      this.$store.commit('mutateEndpoint', {
        endpoint: tko.objects(route),
        response,
      })
      this.$bar.finish()
    },
  },
  created() {
    if (this.hasObjectFilterStatus) {
      this.getStatuses()
    }
    window.addEventListener('click', this.outerClick)
  },
  destroyed() {
    window.removeEventListener('click', this.outerClick)
  },
}
</script>
